/**
 * File: SectionCard.tsx
 * Path: apps/admin/src/shared/components/SectionCard.tsx
 * Description: A titled card used on every admin page. Its h2 sits directly
 * under the page's h1 and names the section; the title and description use
 * the shared text blocks.
 */

import React, { useId } from "react";
import { DescriptionText, TitleText } from "@/shared/components/TextPrimitive";

export const SectionCard: React.FC<{
  title: string;
  description?: string;
  actions?: React.ReactNode;
  /** A name the Help tutorials use to light this card up. */
  tour?: string;
  children: React.ReactNode;
}> = ({ title, description, actions, tour, children }) => {
  const titleId = useId();
  return (
    <section
      aria-labelledby={titleId}
      data-tour={tour}
      className="rounded-none border border-border/50 bg-card text-card-foreground shadow-sm"
    >
      <header className="p-gutter-md pb-stack-xs space-y-stack-xs">
        <div className="flex flex-wrap items-center justify-between gap-stack-sm">
          <TitleText id={titleId}>{title}</TitleText>
          {actions}
        </div>
        {description && <DescriptionText>{description}</DescriptionText>}
      </header>
      <div className="p-gutter-md pt-stack-xs space-y-stack-md">{children}</div>
    </section>
  );
};
